module.exports = __webpack_public_path__ + "static/img/ashray_tmc_thumb.d4ad6b9d.jpg";